import { render, staticRenderFns } from "./aiheader-list.vue?vue&type=template&id=53288059&"
import script from "./aiheader-list.vue?vue&type=script&lang=js&"
export * from "./aiheader-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "aiheader-list.vue"
export default component.exports